module.exports = "/images/vendor/greenmotion-shared/Components/quotes/brand/usave/svgs/checkbox-rounded-checked.svg?3682c3953169ddff941e949aa4505e20";